import React, {FC} from "react"

import {H4} from "@irati/ui/src/Typography"
import {WellnessMedia} from "@irati/types"
import mainTheme from "@irati/ui/src/global/theme"

import {BottomDetailsContainer} from "./styled"
import MediaImportantTags from "../MediaImportantTags"

interface Props {
  media: WellnessMedia
}

const BottomDetails: FC<Props> = ({media}) => {
  return (
    <BottomDetailsContainer direction="column">
      <H4 color="white">{media.title}</H4>
      <MediaImportantTags media={media} color={mainTheme.colors.utility.white} />
    </BottomDetailsContainer>
  )
}

export default BottomDetails
